import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { DataToolsAuth } from '../shared/DataToolsApps';
import { BhAuthService } from './BHAuth/bh-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  private authTokenCookieName = 'KyloeBhAuth';
  private dataCentre = 'auth';
  private isAuthingSubject = new BehaviorSubject<DataToolsAuth>(null);
  public isAuthing$ = this.isAuthingSubject.asObservable();

  constructor(private bhAuthService: BhAuthService,
              private cookieService: CookieService) {}

  checkAuthIsValid(): boolean {
    return this.cookieService.check(this.authTokenCookieName);
  }

  setToken(token: string) {
    this.setAuthCookie(token);
    this.completeAuth();
  }

  get token(): string {
    return this.getAuthCookie();
  }

  public initialiseAuth() {
    this.startAuth();
    this.bhAuthService.initialiseAuth(this.dataCentre);
  }

  public initialiseAuthWithDataCentre(dataCentre: string) {
    this.startAuth();
    if (dataCentre) {
      this.dataCentre = dataCentre;
    } else {
      this.dataCentre = 'auth';
    }
    this.bhAuthService.initialiseAuth(this.dataCentre);
  }

  public startAuth() {
    this.isAuthingSubject.next(DataToolsAuth.IN_PROGRESS);
  }

  public completeAuth() {
    this.isAuthingSubject.next(DataToolsAuth.COMPLETE);
  }

  public getAuthState() {
    return this.isAuthingSubject.getValue();
  }

  private setAuthCookie(token: string) {
    console.log('setting auth cookie to token');
    this.cookieService.delete(this.authTokenCookieName);
    this.cookieService.set(this.authTokenCookieName, token, 1, '/', undefined, false,  'Lax');
    console.log(this.cookieService.get(this.authTokenCookieName));
  }

  private getAuthCookie(): string {
      return this.cookieService.get(this.authTokenCookieName);
  }

}
